/**
 * identity
 *
 * @Date        : 2021-05-06
 * @Description : Vue Plugin，注册认证授权相关方法
 *
 */

import Auth from './auth/index'

/**
 * 初始化配置项
 *
 * @param {*} options
 * @returns
 */
const initOptions = (options) => {
  const defaultOptions = {
    auth: {
      baseApi: ''
    }
  }

  options.auth = Peace.util.merge(defaultOptions.auth, options.auth)

  if (!options.auth.baseApi) {
    return console.error(`
 config.Auth.baseApi is required，check config：
 Vue.use(Identity, {
   auth: {
     baseApi: ''
   }
 })
 `)
  }

  return options
}

/**
 * Vue plugin 加载方法
 *
 * @param {*} Vue
 * @param {*} options
 */
const install = (Vue, options) => {
  window.peace = window.peace || Object.create(new Vue())

  window.peace.identity = Object.create({})

  // 初始化配置项
  options = initOptions(options)

  // 基础配置
  const config = options
  // 权限管理
  const auth = Auth.getInstance(options.auth)

  const identity = {
    config,
    auth
  }

  // 挂载 window
  window.peace.identity = identity
  window.Peace.identity = identity
  window.$peace.identity = identity
  window.$Peace.identity = identity

  // 挂载 Vue
  Vue.prototype.peace.identity = identity
  Vue.prototype.Peace.identity = identity
  Vue.prototype.window = window
  Vue.prototype.$peace.identity = identity
  Vue.prototype.$Peace.identity = identity
  Vue.prototype.$window = window
}

export default {
  version: '0.0.1',
  install
}
